<template>
  <div class="topbar-item">
    <div
      class="
        btn btn-icon
        w-auto
        btn-clean
        d-flex
        align-items-center
        btn-lg
        px-2
      "
      id="kt_quick_user_toggle"
    >
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ currentUserPersonalInfo.name }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
          <!-- :src="
            profile && profile.profile_pic && profile.profile_pic.length > 0
              ? mediaUrl + profile.profile_pic
              : `../images/profile_ch.jpg`
          " -->
        <img
          alt="Pic"
          :src="mediaUrl + profile.profile_pic || ''"
          @error="onImageLoadFailure($event)"
        />
        <!-- //: 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png' -->
        <!-- <span v-if="true" class="symbol-label font-size-h5 font-weight-bold">
          {{ currentUserPersonalInfo.name }}
        </span> -->
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-5
        "
      >
        <h3 class="font-weight-bold m-0">
          {{ currentUserPersonalInfo.first_name }}
          <small class="text-muted font-size-sm ml-2"
            >{{ count }} messages</small
          >
        </h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
              <!-- :src="
                profile && profile.profile_pic.length > 0
                  ? mediaUrl + profile.profile_pic
                  : `../images/profile_ch.jpg`
              " -->
            <img
              class="symbol-label"
              :src="mediaUrl + profile.profile_pic || ''"
              @error="onImageLoadFailure($event)"
              alt=""
            />
            <!-- : 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png' -->
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column">
            <router-link
              to="/custom-pages/profile"
              class="
                font-weight-bold font-size-h5
                text-dark-75 text-hover-primary
              "
            >
              {{ currentUserPersonalInfo && currentUserPersonalInfo.name }}
            </router-link>
            <div class="text-muted mt-1">
              {{ currentUserPersonalInfo.email }}
            </div>
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <span class="svg-icon svg-icon-lg svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Mail-notification.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <!-- <span class="navi-text text-muted text-hover-primary">
                    {{ currentUserPersonalInfo.email }}
                  </span> -->
                </span>
              </a>
            </div>
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              Sign out
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <!--begin::Nav-->
        <div class="navi navi-spacer-x-0 p-0">
          <!--begin::Item-->
          <router-link
            to="/custom-pages/profile"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      src="media/svg/icons/General/Notification2.svg"
                    />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <router-link :to="role == 'Job Seeker' ? '/job-seeker/profile' : '/recruiter/profile'">
                  <div class="font-weight-bold">My Profile</div>
                  <div class="text-muted">
                    Account settings and more
                    <span
                      class="
                        label label-light-danger label-inline
                        font-weight-bold
                      "
                    >
                      update
                    </span>
                  </div>
                </router-link>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
          <!--begin::Item-->
          <router-link
            to="/user/inbox"
            @click.native="closeOffcanvas"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-warning">
                    <!--begin::Svg Icon-->
                    <inline-svg src="media/svg/icons/Shopping/Chart-bar1.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Messages</div>
                <div class="text-muted">Inbox and tasks</div>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
          <!--begin::Item-->
          <router-link
            v-if="role === 'Job Seeker'"
            to="/job-seeker/my-job-applications"
            @click.native="closeOffcanvas"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-danger">
                    <!--begin::Svg Icon-->
                    <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Applications</div>
                <div class="text-muted">Logs and notifications</div>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
          <!--begin::Item-->
          <router-link
            v-if="role === 'Job Seeker'"
            to="/job-seeker/saved-jobs"
            @click.native="closeOffcanvas"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      src="media/svg/icons/Communication/Mail-opened.svg"
                    />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Saved Jobs</div>
                <div class="text-muted">latest tasks and projects</div>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
        </div>
        <!--end::Nav-->
        <div class="separator separator-dashed my-7"></div>
        <!--begin::Notifications-->
        <div>
          <!--begin:Heading-->
          <h5 class="mb-5">Spotlight Jobs</h5>
          <!--end:Heading-->
          <template v-for="(item, i) in spotlightData">
            <!--begin::Item -->
            <div
              class="d-flex align-items-center rounded p-5 gutter-b"
              v-bind:class="`bg-light-${item.type}`"
              v-bind:key="i"
            >
              <span
                class="svg-icon mr-5"
                v-bind:class="`svg-icon-${item.type}`"
              >
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <img
                    :src="mediaUrl + item.recruiter.profile_pic || ''"
                    @error="onImageLoadFailure($event)"
                    width="50"
                  />
                  <!--end::Svg Icon-->
                </span>
              </span>
              <div class="d-flex flex-column flex-grow-1 mr-2">
                <router-link
                  :to="
                    '/jobs-careers/pakistan/' +
                    item.location_city.map((v) => v.toLowerCase()).join('-') +
                    '/' +
                    item.job_title
                      .toLowerCase()
                      .replace(/ /g, '-')
                      .replace(/[^\w-]+/g, '') +
                    '/' +
                    item.id
                  "
                  class="
                    font-weight-normal
                    text-dark-75 text-hover-primary
                    font-size-lg
                    mb-1
                  "
                >
                  {{ item.job_title }}
                </router-link>
                <router-link
                  :to="
                    '/employer/' +
                    item.recruiter.company_name
                      .toLowerCase()
                      .replace(/ /g, '-')+'/'+item.recruiter.id
                  "
                  target="_blank"
                >
                  <span class="text-muted font-size-sm">
                    {{ item.recruiter.company_name }}
                  </span>
                </router-link>
              </div>
              <router-link
                :to="
                  '/jobs-careers/pakistan/' +
                  item.location_city.map((v) => v.toLowerCase()).join('-') +
                  '/' +
                  item.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '/' +
                  item.id
                "
                target="_blank"
              >
                View
              </router-link>
            </div>
            <!--end::Item -->
          </template>
        </div>
        <!--end::Notifications-->
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import { API_URL, MEDIA_URL } from "@/core/api";
import axios from "axios";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning",
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success",
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger",
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info",
        },
      ],
      role: JSON.parse(localStorage.getItem("user")).role,
      mediaUrl: MEDIA_URL,
      API_URL: API_URL,
      spotlightData: [],
      currentUserPersonalInfo:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user"))
          : null,
      profile:
        localStorage.getItem("profile") !== null &&
        localStorage.getItem("profile").length > 10
          ? JSON.parse(localStorage.getItem("profile"))
          : null,
      count:
        localStorage.getItem("inboxCount") !== null
          ? localStorage.getItem("inboxCount")
          : 0,
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    axios.get(`${this.API_URL}/get-spotlight-jobs`).then((response) => {
      this.spotlightData = response.data;
    });
  },
  methods: {
    onLogout() {
      localStorage.clear();
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
  },
};
</script>
